import {
  Flex,
  Image,
  ListItem,
  OrderedList,
  useDisclosure,
} from '@chakra-ui/react';

import asBentoPage from 'common/bento/hoc/asBentoPage';
import Button from 'components/_core/Button';
import Heading from 'components/_core/Heading';
import SunshineCard from 'components/_core/SunshineCard';
import Text from 'components/_core/Text';
import OBNavigation from 'features/Onboarding/components/OBNavigation/OBNavigation';
import ShineStartNextStepInfoModal from 'features/Onboarding/flows/shineStart/components/NextStepInfoModal';

import Fireworks from './assets/Fireworks@2x.png';
import locales from './locales';

interface IntroProps {
  onNext: () => void;
}

const Intro = asBentoPage<IntroProps>(({ Layout, onNext, onPrev }) => {
  const { isOpen, onClose, onOpen } = useDisclosure();

  return (
    <>
      <Layout
        data-testid="verification-home"
        nav={<OBNavigation onPrev={onPrev} />}
      >
        <SunshineCard.Group>
          {/* TODO(REB-107): add Card.Title */}
          <SunshineCard paddingX="space-32" paddingY="space-40">
            <Image
              boxSize="160px"
              marginBottom="space-24"
              marginX="auto"
              src={Fireworks}
            />

            <Heading marginBottom="space-16" size="lg" textAlign="center">
              {locales.cardTitle}
            </Heading>

            <OrderedList>
              {[
                locales.cardStepOne,
                locales.cardStepTwo,
                locales.cardStepThree,
              ].map((stepText) => (
                <ListItem key={stepText} paddingLeft="space-4">
                  <Text>{stepText}</Text>
                </ListItem>
              ))}
            </OrderedList>
          </SunshineCard>

          <SunshineCard>
            <Flex
              alignItems="center"
              justifyContent="space-between"
              padding="space-8"
            >
              <Button onClick={() => onOpen()} variant="inline-primary">
                {locales.howItWorks}
              </Button>

              <Button icon="arrow-right" onClick={onNext}>
                {locales.ctaLabel}
              </Button>
            </Flex>
          </SunshineCard>
        </SunshineCard.Group>
      </Layout>
      <ShineStartNextStepInfoModal isOpen={isOpen} onClose={onClose} />
    </>
  );
});

export default Intro;
